import React, { useEffect, useState } from "react";
import { Text } from "@radix-ui/themes";
import { MediaType } from "../../../models/Task";

interface DocumentProps {
  documentUrl: string;
  fileType: MediaType;
}

const DocumentScreen: React.FC<DocumentProps> = ({ documentUrl, fileType }) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [viewerUrl, setViewerUrl] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isLoaded) {
      try {
        // For all file types, use Google Docs Viewer
        const encodedUrl = encodeURIComponent(documentUrl);
        setViewerUrl(`https://docs.google.com/viewer?url=${encodedUrl}&embedded=true`);
        setIsLoaded(true);
      } catch (err) {
        setError("Failed to load document");
        console.error("Viewer setup error:", err);
      }
    }
  }, [documentUrl, isLoaded]);

  return (
    <div className="w-full h-96">
      {error ? (
        <div className="text-center">
          <Text className="text-red-500">{error}</Text>
          <a href={documentUrl} className="text-blue-500 underline" download>
            Download the file
          </a>
        </div>
      ) : !isLoaded ? (
        <Text className="text-center text-gray-500">Loading document...</Text>
      ) : (
        <iframe
          className="w-full h-96 border-none"
          src={viewerUrl}
          title="Document Viewer"
          sandbox="allow-same-origin allow-scripts"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default DocumentScreen;